import 'select2';

export default (function () {
$.fn.select2.defaults.set( "theme", "bootstrap" );
}())



// WEBPACK FOOTER //
// ./resources/js/admin/select2/index.js